/**
 * @file LoadingSpinner.js
 * @version 2.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2025-11-11
 * @modified 2026-01-30
 * @description Reusable loading spinner component with ellipsis animation
 */

import React from 'react';
import './LoadingSpinner.css';

/**
 * Loading Spinner Component
 *
 * @param {string} message - Optional loading message
 * @param {string} size - Spinner size: 'sm', 'md', 'lg' (default: 'md')
 * @param {string} variant - Style variant: 'primary', 'secondary', 'muted' (default: 'primary')
 * @param {boolean} fullScreen - Whether to display as full-screen overlay (default: false)
 * @param {string} className - Additional CSS classes
 * @param {string} type - Animation type: 'ellipsis', 'spinner' (default: 'ellipsis')
 */
function LoadingSpinner({
  message = '',
  size = 'md',
  variant = 'secondary',
  fullScreen = false,
  className = '',
  type = 'ellipsis'
}) {
  const containerClasses = `
    loading-spinner
    loading-spinner-${size}
    loading-spinner-${variant}
    ${fullScreen ? 'loading-spinner-fullscreen' : ''}
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <div className={containerClasses}>
      {type === 'ellipsis' ? (
        <div className="ellipsis-loader">
          <div className="ellipsis-dot"></div>
          <div className="ellipsis-dot"></div>
          <div className="ellipsis-dot"></div>
        </div>
      ) : (
        <span className="material-symbols-rounded spinning">progress_activity</span>
      )}
      {message && <span className="loading-message">{message}</span>}
    </div>
  );
}

export default LoadingSpinner;
